import { render, staticRenderFns } from "./BirthdayBadge.vue?vue&type=template&id=5976f416&"
import script from "./BirthdayBadge.vue?vue&type=script&lang=js&"
export * from "./BirthdayBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports